<template>
  <v-dialog v-model="visible" scrollable persistent max-width="800" @keydown.esc="cancelForm()">
    <v-card class="location-form-card">
      <v-card-title class="primary white--text py-4">
        <v-icon left color="white">{{ isNewRecord ? 'mdi-map-marker-plus' : 'mdi-map-marker-edit' }}</v-icon>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon dark @click="cancelForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-form ref="ubicacionForm" v-model="validations.isValid">
          <v-container fluid>
            <!-- Información Básica -->
            <v-row>
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-information-outline</v-icon>
                  <span>Información Básica</span>
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="fields.name"
                  :rules="validations.name"
                  :error-messages="errors.name"
                  :disabled="loading"
                  label="Nombre del lugar*"
                  required
                  prepend-inner-icon="mdi-store"
                  outlined
                  dense
                  hint="Nombre con el que se identificará esta ubicación"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Dirección Física -->
            <v-row class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-map-marker</v-icon>
                  <span>Dirección Física</span>
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="fields.address"
                  :rules="validations.address"
                  :error-messages="errors.address"
                  :disabled="loading"
                  label="Dirección completa*"
                  required
                  prepend-inner-icon="mdi-map-marker-radius"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.city"
                  :rules="validations.city"
                  :error-messages="errors.city"
                  :disabled="loading"
                  label="Ciudad*"
                  required
                  prepend-inner-icon="mdi-city"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.zip"
                  :rules="validations.zip"
                  :error-messages="errors.zip"
                  :disabled="loading"
                  label="Código Postal*"
                  required
                  prepend-inner-icon="mdi-code-brackets"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="fields.state"
                  :items="provincias"
                  item-text="name"
                  item-value="name"
                  :rules="validations.state"
                  :error-messages="errors.state"
                  :disabled="loading"
                  label="Provincia*"
                  required
                  prepend-inner-icon="mdi-map"
                  outlined
                  dense
                  auto-select-first
                  :filter="customFilter"
                >
                  <template v-slot:selection="{ item }">
                    <span>{{ item.name }}</span>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                      <v-icon>mdi-map</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            
            <!-- Selección de Dealer (solo para colaboradores)
            <v-row v-if="$store.getters.HAS_ROLE(['colaborator'])" class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-store</v-icon>
                  <span>Asignación de Dealer</span>
                </div>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="fields.dealer_id"
                  :items="availableDealers"
                  :loading="loadingDealers"
                  :rules="$store.getters.HAS_ROLE(['colaborator']) ? validations.dealer_id : []"
                  :error-messages="errors.dealer_id"
                  :disabled="loading"
                  label="Dealer*"
                  item-value="id"
                  item-text="name"
                  required
                  prepend-inner-icon="mdi-store"
                  outlined
                  dense
                  hint="Selecciona el dealer responsable de esta ubicación"
                  persistent-hint
                >
                  <template v-slot:selection="{ item }">
                    <v-icon left small :color="item.is_own ? 'primary' : 'grey'">
                      {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                    </v-icon>
                    {{ item.name }}
                  </template>
                  <template v-slot:item="{ item }">
                    <v-icon left :color="item.is_own ? 'primary' : 'grey'">
                      {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                    </v-icon>
                    <span>{{ item.name }}</span>
                    <v-chip v-if="item.is_own" x-small class="ml-2" color="primary">Propio</v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row> -->
            
            <!-- Información de Contacto -->
            <v-row class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-card-account-phone</v-icon>
                  <span>Información de Contacto</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.phone"
                  :rules="validations.phone"
                  :error-messages="errors.phone"
                  :disabled="loading"
                  label="Teléfono*"
                  required
                  prepend-inner-icon="mdi-phone"
                  outlined
                  dense
                  hint="Teléfono de contacto para esta ubicación"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.email"
                  :rules="validations.email"
                  :error-messages="errors.email"
                  :disabled="loading"
                  label="Correo Electrónico*"
                  required
                  prepend-inner-icon="mdi-email"
                  outlined
                  dense
                  hint="Correo electrónico para comunicaciones"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-list-status</v-icon>
                  <span>Estado Proceso</span>
                </div>
              </v-col>
              <v-col cols="12">
                <!-- Input de búsqueda -->
                <v-text-field
                  v-model="estadoProcesoSearch"
                  :disabled="loading"
                  label="Buscar Estados de Proceso"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  dense
                  clearable
                  hint="Escribe para buscar estados de proceso"
                  persistent-hint
                  class="mb-3"
                ></v-text-field>
                
                <!-- Estados seleccionados -->
                <div v-if="selectedEstadosProceso.length > 0" class="mb-4" :key="`selected-section-${forceUpdateKey}`">
                  <div class="text-subtitle-2 mb-2">Estados Seleccionados:</div>
                  <div class="d-flex flex-wrap" :key="`selected-wrapper-${forceUpdateKey}`">
                    <div 
                      v-for="(estado, index) in selectedEstadosProceso"
                      :key="`selected-${estado.id}-${forceUpdateKey}-${index}`"
                      class="estado-circle-container mr-3 mb-2"
                    >
                      <div 
                        class="estado-circle estado-selected"
                        :style="`background-color: ${estado.button_color}; color: ${estado.text_color};`"
                      >
                        <span class="estado-letra">{{ estado.name.charAt(0).toUpperCase() }}</span>
                        <div
                          class="estado-close-btn"
                          @click="removeEstadoProceso(estado)"
                          :style="`color: ${estado.text_color}; border-color: ${estado.text_color};`"
                        >
                          ×
                        </div>
                      </div>
                      <div class="estado-tooltip">{{ estado.name }}</div>
                    </div>
                  </div>
                </div>
                
                <!-- Grid de estados disponibles -->
                <div class="text-subtitle-2 mb-2">Estados Disponibles:</div>
                <div 
                  class="estados-grid pa-3" 
                  style="border: 1px solid #e0e0e0; border-radius: 4px; min-height: 120px; max-height: 300px; overflow-y: auto;"
                >
                  <div v-if="filteredEstadosProceso.length === 0" class="text-center text--disabled py-4">
                    <v-icon color="grey lighten-1">mdi-information-outline</v-icon>
                    <div>No se encontraron estados de proceso</div>
                  </div>
                  <div v-else class="d-flex flex-wrap">
                    <div 
                      v-for="estado in filteredEstadosProceso"
                      :key="estado.id"
                      class="estado-circle-container mr-3 mb-3"
                      :class="{ 'estado-disabled': isEstadoSelected(estado) }"
                    >
                      <div 
                        class="estado-circle estado-available"
                        :style="`background-color: ${estado.button_color}; color: ${estado.text_color};`"
                        @click="selectEstadoProceso(estado)"
                      >
                        <span class="estado-letra">{{ estado.name.charAt(0).toUpperCase() }}</span>
                        <v-icon 
                          v-if="isEstadoSelected(estado)"
                          class="estado-check" 
                          x-small 
                          :style="`color: ${estado.text_color};`"
                        >
                          mdi-check
                        </v-icon>
                      </div>
                      <div class="estado-tooltip">{{ estado.name }}</div>
                    </div>
                  </div>
                </div>
                
                <!-- Mensaje de validación -->
                <div v-if="errors.estado_proceso_ids.length > 0" class="v-messages error--text mt-1">
                  <div class="v-messages__message">{{ errors.estado_proceso_ids[0] }}</div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="loading"
          @click="cancelForm()"
          color="grey darken-1"
          text
          class="px-4"
        >
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          :loading="loading"
          :disabled="!validations.isValid"
          @click="saveForm()"
          color="primary"
          class="px-4"
          depressed
        >
          <v-icon left>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DealerService from '../../services/DealerService'
import { mapGetters } from 'vuex'
import EstadoProcesoService from '../../services/EstadoProcesoService'

export default {
  props: {
    value: null
  },

  data: () => ({
    visible: true,
    loading: false,
    gettingCoordinates: false,
    loadingDealers: false,
    loadingEstadosProceso: false,
    estadoProcesoSearch: '',
    dealer_name: '',
    forceUpdateKey: 0, // Variable para forzar re-renderizado
    
    // Dealers accesibles (para colaboradores)
    availableDealers: [],
    availableEstadosProceso: [],
    
    provincias: [
      { 'name': 'Álava' },
      { 'name': 'Albacete' },
      { 'name': 'Alicante' },
      { 'name': 'Almería' },
      { 'name': 'Asturias' },
      { 'name': 'Ávila' },
      { 'name': 'Badajoz' },
      { 'name': 'Baleares' },
      { 'name': 'Barcelona' },
      { 'name': 'Burgos' },
      { 'name': 'Cáceres' },
      { 'name': 'Cádiz' },
      { 'name': 'Cantabria' },
      { 'name': 'Castellón' },
      { 'name': 'Ciudad Real' },
      { 'name': 'Córdoba' },
      { 'name': 'Cuenca' },
      { 'name': 'Girona' },
      { 'name': 'Granada' },
      { 'name': 'Guadalajara' },
      { 'name': 'Guipúzcoa' },
      { 'name': 'Huelva' },
      { 'name': 'Huesca' },
      { 'name': 'Jaén' },
      { 'name': 'La Coruña' },
      { 'name': 'La Rioja' },
      { 'name': 'Las Palmas' },
      { 'name': 'León' },
      { 'name': 'Lleida' },
      { 'name': 'Lugo' },
      { 'name': 'Madrid' },
      { 'name': 'Málaga' },
      { 'name': 'Murcia' },
      { 'name': 'Navarra' },
      { 'name': 'Ourense' },
      { 'name': 'Palencia' },
      { 'name': 'Pontevedra' },
      { 'name': 'Salamanca' },
      { 'name': 'Santa Cruz de Tenerife' },
      { 'name': 'Segovia' },
      { 'name': 'Sevilla' },
      { 'name': 'Soria' },
      { 'name': 'Tarragona' },
      { 'name': 'Teruel' },
      { 'name': 'Toledo' },
      { 'name': 'Valencia' },
      { 'name': 'Valladolid' },
      { 'name': 'Vizcaya' },
      { 'name': 'Zamora' },
      { 'name': 'Zaragoza' }
    ],
    validations: {
      isValid: true,
      name: [
        (v) => !!v || 'Debe proporcionar un nombre.'
      ],
      address: [
        (v) => !!v || 'Debe proporcionar una dirección.'
      ],
      city: [
        (v) => !!v || 'Debe proporcionar una ciudad.'
      ],
      state: [
        (v) => !!v || 'Debe proporcionar una provincia.'
      ],
      zip: [
        (v) => !!v || 'Debe proporcionar un código postal.',
        (v) => /^[0-9]+$/.test(v) || 'El código postal solo puede contener números.'
      ],
      phone: [
        (v) => !!v || 'Debe proporcionar un teléfono.',
        (v) => /^[0-9]+$/.test(v) || 'El teléfono solo puede contener números.'
      ],
      email: [
        (v) => !!v || 'Debe proporcionar un correo electrónico.',
        (v) => /.+@.+\..+/.test(v) || 'Debe ser un correo electrónico válido.'
      ],
      dealer_id: [
        (v) => !!v || 'Debe seleccionar un dealer.'
      ],
      estado_proceso_ids: [
        (v) => (v && v.length > 0) || 'Debe seleccionar al menos un estado de proceso.'
      ]
    },
    errors: {
      name: [],
      address: [],
      city: [],
      state: [],
      zip: [],
      phone: [],
      email: [],
      latitude: [],
      longitude: [],
      dealer_id: [],
      estado_proceso_ids: []
    },
    fields: {
      name: null,
      address: null,
      city: null,
      state: null,
      zip: null,
      phone: null,
      email: null,
      latitude: null,
      longitude: null,
      dealer_id: null,
      estado_proceso_ids: [] // Array para almacenar los IDs de estados de proceso seleccionados
    }
  }),

  methods: {
    customFilter (item, queryText) {
      const text = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    
    removeEstadoProceso (item) {
      if (!this.fields.estado_proceso_ids || !Array.isArray(this.fields.estado_proceso_ids)) {
        return
      }
      
      // Filtrar directamente el array para eliminar el ID
      const newArray = this.fields.estado_proceso_ids.filter(id => id !== item.id)
      
      // Usar Vue.set para forzar reactividad
      this.$set(this.fields, 'estado_proceso_ids', newArray)
      
      // Incrementar la key para forzar re-renderizado completo
      this.forceUpdateKey++
      
      // Forzar re-renderizado
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    
    selectEstadoProceso (estado) {
      if (!this.fields.estado_proceso_ids) {
        this.fields.estado_proceso_ids = []
      }
      if (!this.isEstadoSelected(estado)) {
        // Crear nuevo array para forzar reactividad
        const newArray = [...this.fields.estado_proceso_ids, estado.id]
        
        // Usar Vue.set para forzar reactividad
        this.$set(this.fields, 'estado_proceso_ids', newArray)
        
        // Incrementar la key para forzar re-renderizado completo
        this.forceUpdateKey++
        
        // Limpiar errores cuando se selecciona un estado
        this.errors.estado_proceso_ids = []
        
        // Forzar re-renderizado
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    },
    
    isEstadoSelected (estado) {
      if (!this.fields.estado_proceso_ids || !Array.isArray(this.fields.estado_proceso_ids)) {
        return false
      }
      // Convertir ambos a strings para comparación segura
      const selectedIds = this.fields.estado_proceso_ids.map(id => String(id))
      return selectedIds.includes(String(estado.id))
    },
    async getCoordinates () {
      if (!this.fields.address || !this.fields.city || !this.fields.state) {
        this.$toast.warning('Completa primero la dirección, ciudad y provincia')
        return
      }
      this.gettingCoordinates = true
      try {
        // Esta función simula la obtención de coordenadas
        // En una implementación real usarías un servicio de geocodificación como Google Maps
        await new Promise(resolve => setTimeout(resolve, 1000))
        // Valores simulados para demostración
        // En una implementación real, estos valores vendrían de una API de geocodificación
        const randomLat = 40 + Math.random() * 2
        const randomLng = -3 - Math.random() * 2
        this.fields.latitude = randomLat.toFixed(6)
        this.fields.longitude = randomLng.toFixed(6)
        this.$toast.success('Coordenadas obtenidas correctamente')
      } catch (error) {
        this.$toast.error('Error al obtener las coordenadas')
        console.error('Error al obtener coordenadas:', error)
      } finally {
        this.gettingCoordinates = false
      }
    },
    saveForm () {
      this.$refs.ubicacionForm.validate()
      if (this.validations.isValid) {
        this.loading = true

        let location = Object.assign({}, this.fields)
        
        // Asignar dealer_id según el rol y tipo de operación
        if (!location.dealer_id) {
          // Si es colaborador creando una nueva ubicación, usar su propio dealer
          location.dealer_id = this.CURRENT_USER.dealer.id
        }
        // Si no es colaborador o es una edición, mantener el dealer_id existente (si lo tiene)
        
        this.$store.dispatch(this.isNewRecord ? 'ADD_LOCATION' : 'UPDATE_LOCATION', location).then(response => {
          let { error, data, status } = response
          if (error) {
            if (status === 422) {
              // mostrando los errores de validación en los campos correspondientes
              data.forEach(({ field, message }) => {
                if (this.errors[field]) {
                  this.errors[field].push(message)
                }
              })
            } else {
              // mostrando cualquier otro error al usuario en una notificación
              this.$toast.error('Ocurrió un error al intentar registrar o actualizar la ubicación')
            }
          } else {
            this.$toast.success(`Ubicación ${this.isNewRecord ? 'creada' : 'actualizada'} correctamente`)
            this.$emit('save', { insert: this.isNewRecord, value: data })
            this.visible = false
          }
          this.loading = false
        })
      }
    },
    
    async loadAvailableDealers () {
      if (!this.$store.getters.HAS_ROLE(['colaborator'])) {
        return // Solo cargar para colaboradores
      }

      try {
        this.loadingDealers = true
        const response = await DealerService.getMyAccessibleDealers()
        
        // Verificar la estructura de la respuesta
        let dealersArray = []
        if (response.data && response.data.data && Array.isArray(response.data.data.data)) {
          dealersArray = response.data.data.data
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          dealersArray = response.data.data
        } else if (response.data && Array.isArray(response.data)) {
          dealersArray = response.data
        }
        
        this.availableDealers = dealersArray
      } catch (error) {
        console.error('Error al cargar dealers accesibles:', error)
        this.$toast.error('Error al cargar la lista de dealers')
      } finally {
        this.loadingDealers = false
      }
    },

    async loadAvailableEstadosProceso () {
      try {
        this.loadingEstadosProceso = true
        const response = await EstadoProcesoService.get()

        // Verificar la estructura de la respuesta
        let estadosArray = []
        if (response.data && response.data.data && Array.isArray(response.data.data.data)) {
          estadosArray = response.data.data.data
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          estadosArray = response.data.data
        } else if (response.data && Array.isArray(response.data)) {
          estadosArray = response.data
        }

        this.availableEstadosProceso = estadosArray
      } catch (error) {
        console.error('Error al cargar estados de proceso:', error)
        this.$toast.error('Error al cargar la lista de estados de proceso')
      } finally {
        this.loadingEstadosProceso = false
      }
    },

    cancelForm () {
      this.$emit('cancel')
    }
  },
  async created () {
    // Cargar dealers accesibles si es colaborador
    if (this.$store.getters.HAS_ROLE(['colaborator'])) {
      await this.loadAvailableDealers()
    }

    // Cargar los estados de proceso disponibles primero
    await this.loadAvailableEstadosProceso()

    if (this.value) {
      this.loading = true
      
      try {
        // Obtener los datos completos de la ubicación - solo enviar el ID
        const response = await this.$store.dispatch('VIEW_LOCATION', { id: this.value.id })
        
        // Usar los datos del response en lugar de this.value
        const locationData = response.data || response || this.value
        
        // Asignar todos los campos básicos
        this.fields = Object.assign({}, locationData)
        
        // Asegurar que estado_proceso_ids sea siempre un array
        this.fields.estado_proceso_ids = []
        
        // Si es colaborador y la ubicación tiene dealer, cargar el dealer_id
        if (this.$store.getters.HAS_ROLE(['colaborator']) && locationData.dealer) {
          this.fields.dealer_id = locationData.dealer.id
        }
        
        // Cargar los estado_proceso_ids existentes - probar múltiples formatos
        
        if (locationData.estadoProcesos && Array.isArray(locationData.estadoProcesos)) {
          this.fields.estado_proceso_ids = locationData.estadoProcesos.map(estado => estado.id || estado)
        } else if (locationData.estado_procesos && Array.isArray(locationData.estado_procesos)) {
          this.fields.estado_proceso_ids = locationData.estado_procesos.map(estado => estado.id || estado)
        } else if (locationData.estadoProcesoIds && Array.isArray(locationData.estadoProcesoIds)) {
          this.fields.estado_proceso_ids = [...locationData.estadoProcesoIds]
        } else if (locationData.estado_proceso_ids && Array.isArray(locationData.estado_proceso_ids)) {
          this.fields.estado_proceso_ids = [...locationData.estado_proceso_ids]
        } else if (locationData.estado_proceso) {
          // Para compatibilidad con versiones anteriores que solo tenían un estado
          this.fields.estado_proceso_ids = [locationData.estado_proceso.id || locationData.estado_proceso]
        } else {
        }
        
        // Log final del estado
      } catch (error) {
        console.error('Error al cargar la ubicación:', error)
        this.$toast.error('Error al cargar los datos de la ubicación')
      } finally {
        this.loading = false
      }
    }
  },

  computed: {
    ...mapGetters(['CURRENT_USER']),
    isNewRecord () {
      return !this.value
    },
    title () {
      return this.isNewRecord ? 'Nueva Ubicación' : 'Modificar Ubicación'
    },
    
    filteredEstadosProceso () {
      if (!this.estadoProcesoSearch) {
        return this.availableEstadosProceso
      }
      return this.availableEstadosProceso.filter(estado => 
        estado.name.toLowerCase().includes(this.estadoProcesoSearch.toLowerCase())
      )
    },
    
    selectedEstadosProceso () {
      // Incluir forceUpdateKey para forzar recálculo (silenciar ESLint)
      // eslint-disable-next-line no-unused-expressions
      this.forceUpdateKey
      
      if (!this.fields.estado_proceso_ids || !Array.isArray(this.fields.estado_proceso_ids)) {
        return []
      }
      
      // Convertir ambos a strings para comparación segura
      const selectedIds = this.fields.estado_proceso_ids.map(id => String(id))
      
      const result = this.availableEstadosProceso.filter(estado => 
        selectedIds.includes(String(estado.id))
      )
      
      return result
    }
  },
  
  watch: {
    'fields.estado_proceso_ids': {
      handler(newVal, oldVal) {
        this.$forceUpdate()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.location-form-card {
  border-radius: 8px;
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.87);
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.section-title .v-icon {
  margin-right: 8px;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-select.v-select--enclosed .v-select__details {
  margin-bottom: 8px;
}

.estados-grid {
  background-color: #fafafa;
}

.estado-circle-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.estado-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.estado-selected {
  cursor: default !important;
}

.estado-circle:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  border-color: rgba(0,0,0,0.2);
}

.estado-letra {
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  z-index: 1;
}

.estado-close {
  position: absolute;
  top: -2px;
  right: -2px;
  background: rgba(255,255,255,0.9);
  border-radius: 50%;
  padding: 2px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.estado-close-btn {
  position: absolute !important;
  top: -8px !important;
  right: -8px !important;
  background-color: rgba(255,255,255,0.95) !important;
  border: 1px solid !important;
  border-radius: 50% !important;
  width: 20px !important;
  height: 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 14px !important;
  font-weight: bold !important;
  cursor: pointer !important;
  z-index: 10 !important;
  transition: all 0.2s ease !important;
  line-height: 1 !important;
  user-select: none;
}

.estado-close-btn:hover {
  background-color: #ff5252 !important;
  color: white !important;
  border-color: #ff5252 !important;
  transform: scale(1.1) !important;
}

.estado-circle:hover .estado-close {
  opacity: 1;
}

.estado-check {
  position: absolute;
  bottom: -2px;
  right: -2px;
  background: rgba(255,255,255,0.9);
  border-radius: 50%;
  padding: 2px;
}

.estado-tooltip {
  font-size: 11px;
  margin-top: 4px;
  text-align: center;
  max-width: 60px;
  word-wrap: break-word;
  line-height: 1.2;
}

.estado-available:not(.estado-disabled) {
  cursor: pointer;
}

.estado-disabled {
  opacity: 0.5;
}

.estado-disabled .estado-circle {
  cursor: not-allowed;
  pointer-events: none;
}

.chip-disabled {
  opacity: 0.6 !important;
  pointer-events: none !important;
}

.v-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.12);
  transition: all 0.2s ease;
}

.v-messages.error--text .v-messages__message {
  font-size: 12px;
}
</style>
